class Popup {
    overlay;
    popup;
    btnClose;
    btnsOpenPopup;

    constructor(elm){
        this.popup = elm;
        this.overlay = document.querySelector('#popupOverlay');
        this.btnClose = this.popup.querySelector('#closePopup');
        this.btnsOpenPopup = document.querySelectorAll('.btn-popup');
        this.init();
    }

    init() {
        this.btnsOpenPopup.forEach(elm => elm.addEventListener('click', this.#openPopup));

        this.btnClose.addEventListener('click', (e) => {
            e.preventDefault();
            this.#closePopup();
        })

        this.overlay.addEventListener('click', (e) => {
            //e.preventDefault();
            if (e.target === this.overlay) {
                this.#closePopup();
            }
        })

        document.addEventListener('wpcf7mailsent', (e) => {
            setTimeout(() => {
                this.#closePopup();
            }, 1500);
            
        }, false);
    }

    #openPopup = (e) => {
        this.overlay.classList.add('active');
        document.body.classList.add('lock');
    }

    #closePopup() {
        this.overlay.classList.remove('active');
        document.body.classList.remove('lock');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elemetns = document.querySelectorAll('.popup');
    elemetns.forEach(elm => new Popup(elm));
})